import spaceProfessionalOfficeThumbnail from './assets/thumbnails/space_professional-office.png'
import spaceOfficeThumbnail from './assets/thumbnails/space_office.png'
import spaceCoffeeShopThumbnail from './assets/thumbnails/space_coffee-shop.png'
import spaceTropicalBeachThumbnail from './assets/thumbnails/space_tropical-beach.png'
import spaceBookshelfThumbnail from './assets/thumbnails/space_bookshelf.png'
import spaceCozyLivingRoomThumbnail from './assets/thumbnails/space_cozy-living-room.png'
import styleCinematicThumbnail from './assets/thumbnails/style_cinematic.png'
import styleAnimeThumbnail from './assets/thumbnails/style_anime.png'
import styleMangaThumbnail from './assets/thumbnails/style_manga.png'
import stylePixelArtThumbnail from './assets/thumbnails/style_pixel-art.png'
import styleFantasyThumbnail from './assets/thumbnails/style_fantasy.png'

// TODO: Discuss with PM on generic error message for VB in Client Setting
export const ERROR_MESSAGE_GENERIC_CLIENT_SETTING =
  'Please refresh to continue using Virtual Backgrounds'

export const ERROR_MESSAGE_FAILED_TO_GENERATE =
  'Images failed to generate. Please try again.'

export const ERROR_MESSAGE_RATE_LIMIT =
  'You’ve reached the limit of generated images for now. Please try again later.'

export const ERROR_MESSAGE_PROMPT_ADJUSTED =
  'We adjusted your prompt to follow our content guidelines'

export const GENERATE_IMAGE_LOADING_TEXT =
  'Images may take about a minute to generate.'

export const ADD_IMAGE_SUCCESS_TEXT = 'Your image has been saved.'

export const LAST_VB_RECOMMENDATION_INDEX = 'lastVBRecommendationIndex'

export const SHOWN_SUPPORT_LANGUAGE_KEY = 'shownSupportLanguage'

export const SUPPORT_ONLY_ENGLISH_LANGUAGE_MESSAGE =
  'Generating Virtual Backgrounds currently only supports the English language.'

export const STYLE_OPTIONS = [
  { value: 'Cinematic', thumbnail: styleCinematicThumbnail },
  { value: 'Anime', thumbnail: styleAnimeThumbnail },
  { value: 'Manga', thumbnail: styleMangaThumbnail },
  { value: 'Pixel Art', thumbnail: stylePixelArtThumbnail },
  { value: 'Fantasy', thumbnail: styleFantasyThumbnail },
]

export const SPACE_OPTIONS = [
  {
    id: 'office',
    label: 'Office',
    thumbnail: spaceOfficeThumbnail,
  },
  {
    id: 'professional-office',
    label: 'Professional office',
    thumbnail: spaceProfessionalOfficeThumbnail,
  },
  {
    id: 'coffee-shop',
    label: 'Coffee shop',
    thumbnail: spaceCoffeeShopThumbnail,
  },
  {
    id: 'tropical-beach',
    label: 'Tropical beach',
    thumbnail: spaceTropicalBeachThumbnail,
  },
  {
    id: 'bookshelf',
    label: 'Bookshelf',
    thumbnail: spaceBookshelfThumbnail,
  },
  {
    id: 'cozy-living-room',
    label: 'Cozy living room',
    thumbnail: spaceCozyLivingRoomThumbnail,
  },
]

export const RECOMMENDATIONS = [
  'River passing through a canyon',
  'Clouds viewed from a mountain peak',
  'Classic theater',

  'Modern office overlooking a beach',
  'Kelp forest',
  'Conference room with view of the mountains',

  'Cozy living room',
  'Mid-century modern library',
  'Lake in front of mountain during autumn',

  'City skyline at night',
  'Sand dunes during sunset',
  'Outdoor garden with blooming flowers',

  'University lecture hall',
  'Waterfall in a tropical jungle',
  'Rolling hills at dawn',
]
